export default __webpack_public_path__ + "static/media/UP2_icon.30bd45d8.svg";